module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_04@2x-039bb7ed5042b009ab546e39e8df19d8.jpg";